import BasePage from "../../../../base/BasePage";
// import {NavBar} from "nq-component";
import NavBar from "../../../../components/navigation";
import React from "react";
import PersonnelActionPresenter from "./PersonnelActionPresenter";
import { Button } from "nq-component";
import browseFile from "../../../../browseFile";
import { addSchemaUseCase } from "../../../../usecases/schema/usecases";
import CardView from "../../../../components/common/CardView";
import RegionTab from "../../../../components/common/RegionTab";
import TardinessPage from "./PersonnelActionTable/Tardiness/TardinessPage";
import UnderTimePage from "./PersonnelActionTable/Undertime/UnderTimePage";
import LeaveWoPayPage from "./PersonnelActionTable/LeaveWithoutPay/LeaveWoPayPage";
import ProfileNoticesPage from "./PersonnelActionTable/Notices/ProfileNoticesPage";

class PersonnelActionPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new PersonnelActionPresenter(this, addSchemaUseCase());
    this.state = { progress: false };
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  render() {
    const tabs = [
      // {
      //   title: "Tardiness",
      //   content: <TardinessPage employee={this.props.employee} />,
      // },
      // {
      //   title: "Undertime",
      //   content: <UnderTimePage employee={this.props.employee} />,
      // },
      {
        title: "Leave Without Pay",
        content: <LeaveWoPayPage employee={this.props.employee} />,
      },
      {
        title: "Notice",
        content: <ProfileNoticesPage employee={this.props.employee} />,
      },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="row m-auto w-100 h-100 mb-2 "
          style={{ height: "300px" }}
        >
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default PersonnelActionPage;
